import { useState, useEffect } from 'react';
import { staffService } from '../services/api';
import { StaffModal } from '../components/StaffModal';
import { useAuth } from '../contexts/AuthContext';
import './Team.css';

export default function Team() {
  const { user } = useAuth();
  const isOwner = user?.role === 'owner';
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);

  async function load() {
    setLoading(true);
    const res = await staffService.getAll();
    if (res.success) setStaff(res.staff || []);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function deactivate(e, p) {
    e.stopPropagation();
    if (!window.confirm(`Deactivate ${p.name}? Their appointments are kept.`)) return;
    await staffService.deactivate(p.id);
    load();
  }

  return (
    <div className="team-page">
      <div className="page-header">
        <h1 className="page-title">Team</h1>
        {isOwner && <button className="btn btn-primary" onClick={() => setModal({ create: true })}>+ Add Person</button>}
      </div>

      {loading ? (
        <div className="empty-state"><div className="loading-spinner"></div></div>
      ) : (
        <div className="card-grid">
          {staff.map((p) => (
            <div key={p.id} className={`team-card ${p.is_active ? '' : 'inactive'}`} onClick={() => isOwner && setModal({ person: p })} style={{ cursor: isOwner ? 'pointer' : 'default' }}>
              <div className="team-avatar" style={{ background: p.color || 'var(--color-teal)' }}>{p.name?.[0] || '?'}</div>
              <div className="team-info">
                <h3>{p.name} {p.role === 'owner' && <span className="chip">Owner</span>}</h3>
                <p className="text-muted">{p.email}</p>
                <p className="text-muted">/book/{p.slug}</p>
                <div className="team-flags">
                  {p.is_bookable ? <span className="chip chip-extra">Bookable</span> : <span className="chip chip-muted">Not bookable</span>}
                  {!p.is_active && <span className="chip chip-muted">Inactive</span>}
                </div>
              </div>
              {isOwner && p.id !== user?.id && p.is_active && (
                <button className="btn btn-sm btn-outline team-deactivate" onClick={(e) => deactivate(e, p)}>Deactivate</button>
              )}
            </div>
          ))}
        </div>
      )}

      <StaffModal isOpen={!!modal} onClose={() => setModal(null)} onSave={() => { setModal(null); load(); }} person={modal?.person || null} />
    </div>
  );
}
